import { render, staticRenderFns } from "./RecoveryDetailsPart.vue?vue&type=template&id=8a7e4208"
import script from "./RecoveryDetailsPart.vue?vue&type=script&lang=js"
export * from "./RecoveryDetailsPart.vue?vue&type=script&lang=js"
import style0 from "./RecoveryDetailsPart.vue?vue&type=style&index=0&id=8a7e4208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports